import React, {useLayoutEffect, useCallback} from 'react';

let stack = new Map(); //Map is choosen for the order of addition will be guaranteed to be preserved

export default function EscHandler(props) {
  let escHandler = useCallback(() => {
    let methods = {};
    methods.addEscListener = (id, listener) => {
      console.log('addEscListener', id);
      console.log('stack', stack);
      stack.set(id, listener);
    }
    methods.removeEscListener = (id) => {
      console.log('removeEscListener', id)
      if (id && stack.has(id)) stack.delete(id);
    }

    methods.getEscListener = (id) => {
      console.log('getEscListener', stack.get(id))
      if (id && stack.has(id)) return stack.get(id);
    }
    return methods;
  }, []);

  let runListener = e => {
    if (e.key !== 'Escape') return;

    let stackLength = stack.size;

    if (!stackLength) return;

    const lastKey = Array.from(stack.keys()).pop(),
      lastListener = stack.get(lastKey);

    if (typeof lastListener === 'function') {
      console.log('runEscListener', lastKey)
      lastListener(e); //run only last escape handler in the stack

      if (!window.dontDeleteEscHandler) {
        stack.delete(lastKey); //delete already completed listener
      } else {
        window.dontDeleteEscHandler = false; //skip deleeting
      }

    }
  }

  useLayoutEffect(() => { //used instead of useEffect to be synchronous
    window.escHandler = escHandler();
    document.addEventListener("keydown", runListener);
    return () => {
      window.escHandler = undefined;
      document.removeEventListener("keydown", runListener);
    }
  }, [])

  return null;
}